/**
* Image Shapes Block JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Shapes Block component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'image-shapes-block',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.image-shapes-block' ).length ) {
        if ( window.hasMotion ) {
          $( '.image-shapes-block .js-dove-fade' ).each( function( index, element ) {
            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: $( element ),
                start: 'top-=50px 70%',
                stagger: 0.1,
              },
            } );
            tl.from( $( element ), 2, {opacity: 0}, 0 );
            tl.to( $( element ), 2, {x: '0', y: '0'}, 0 );
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-shapes-block', COMPONENT );
} )( app );
